var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgFillTool = function SvgFillTool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.819 12.488l1.178-1.178 1.178 1.178a1.667 1.667 0 11-2.357 0zM5.918.72l7.542 7.542c.26.26.26.683 0 .943l-5.656 5.657a.667.667 0 01-.943 0L1.205 9.205a.667.667 0 010-.943L6.39 3.077 4.976 1.663 5.92.72zm1.414 3.3L2.62 8.734h9.428L7.333 4.02z",
    fill: "#666"
  })));
};
export default SvgFillTool;